/**
 * Floating Emotion Illustrations
 * Adds gentle floating animations and mouse-tracking tilt effects
 */

export function initEmotionFloats() {
    const heroContainer = document.getElementById('hero-emotions');
    if (!heroContainer) return;

    const emotions = document.querySelectorAll('.emotion-float');
    if (!emotions.length) return;

    // Track mouse position
    let mouseX = 0;
    let mouseY = 0;
    let isMouseInHero = false;

    // Update mouse position
    heroContainer.addEventListener('mousemove', (e) => {
        const rect = heroContainer.getBoundingClientRect();
        mouseX = e.clientX - rect.left;
        mouseY = e.clientY - rect.top;
        isMouseInHero = true;
    });

    heroContainer.addEventListener('mouseleave', () => {
        isMouseInHero = false;
    });

    // Animate each emotion
    emotions.forEach((emotion, index) => {
        const speed = parseFloat(emotion.dataset.floatSpeed) || 2;
        const range = parseFloat(emotion.dataset.floatRange) || 15;

        // Random starting offset for variety
        const startOffset = Math.random() * Math.PI * 2;

        let time = startOffset;

        function animate() {
            time += 0.01 * speed;

            // Floating motion (sine wave)
            const floatY = Math.sin(time) * range;
            const floatX = Math.cos(time * 0.7) * (range * 0.5);

            // Mouse tracking tilt
            let tiltX = 0;
            let tiltY = 0;
            let rotation = 0;

            if (isMouseInHero) {
                const rect = emotion.getBoundingClientRect();
                const emotionCenterX = rect.left + rect.width / 2 - heroContainer.getBoundingClientRect().left;
                const emotionCenterY = rect.top + rect.height / 2 - heroContainer.getBoundingClientRect().top;

                // Calculate angle to mouse
                const dx = mouseX - emotionCenterX;
                const dy = mouseY - emotionCenterY;
                const distance = Math.sqrt(dx * dx + dy * dy);

                // Subtle tilt toward mouse (max 8 degrees)
                const maxDistance = 500;
                const influence = Math.max(0, 1 - distance / maxDistance);

                tiltX = (dy / distance) * influence * 8;
                tiltY = (dx / distance) * influence * -8;

                // Subtle rotation toward mouse
                const angle = Math.atan2(dy, dx);
                rotation = (angle * (180 / Math.PI)) * influence * 0.05;
            }

            // Apply transform
            emotion.style.transform = `
                translate(${floatX + tiltY}px, ${floatY + tiltX}px)
                rotate(${rotation}deg)
            `;

            requestAnimationFrame(animate);
        }

        // Start animation with staggered delay
        setTimeout(() => {
            animate();
        }, index * 100);
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmotionFloats);
} else {
    initEmotionFloats();
}
